import { gql } from '@apollo/client';

/**
 * BankID Authentication Subscription
 * Subscribes to authentication updates during BankID login flow
 */
export const AUTH_SUBSCRIPTION = gql`
	subscription OnAuthenticationUpdate($input: OnAuthenticationUpdateInput!) {
		onAuthenticationUpdate(input: $input) {
			details
			id
			returnUrl
			type
			tokens {
				token
				tokenExpiration
				refreshToken
				refreshTokenExpiration
				customerId
				customer {
					customerNumber
					name
					isCompany
					nationalId
				}
			}
		}
	}
`;

/**
 * BankID Authentication Mutation
 * Initiates BankID authentication and returns QR code data
 */
export const BANKID_MUTATION = gql`
	mutation TokenByBankId($input: TokenByBankIdInput!) {
		tokenByBankId(input: $input) {
			bankIdResponse {
				autoStartToken
				firstQrCode
				id
				orderRef
			}
		}
	}
`;

/**
 * Refresh Token Mutation
 * Exchanges a valid refresh token for new access and refresh tokens
 */
export const REFRESH_TOKEN_MUTATION = gql`
	mutation TokenByRefreshToken($input: TokenByRefreshTokenInput!) {
		tokenByRefreshToken(input: $input) {
			bearerToken {
				customerId
				refreshToken
				refreshTokenExpiration
				token
				tokenExpiration
			}
		}
	}
`;
